module.exports = __webpack_public_path__ + "img/gmv-icon.8a67999c.png";